var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"rph-header-burger",attrs:{"title":"Открыть меню"},on:{"click":_vm.handler}},[_c('i'),_c('i'),_c('i')])
}
var staticRenderFns = []

export { render, staticRenderFns }